import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Card, CardActionArea, CardContent, CardActions, Grid, Stack, TextField, Typography } from '@mui/material';
import { getHotels, Hotel } from '../../api/hotels.ts';
import { toastError } from '../../shared/ui/toast.ts';
import { useNavigate } from 'react-router-dom';

const HotelsPage: React.FC = () => {
  const [hotels, setHotels] = useState<Hotel[]>([]);
  const [q, setQ] = useState(() => localStorage.getItem('hotels_filter_q') || '');
  const nav = useNavigate();

  useEffect(() => {
    getHotels().then(setHotels).catch((e) => {
      const msg = e?.response?.data?.error || 'Failed to load hotels';
      toastError(msg);
    });
  }, []);

  useEffect(() => { localStorage.setItem('hotels_filter_q', q); }, [q]);

  const filtered = useMemo(() => {
    const qq = q.trim().toLowerCase();
    if (!qq) return hotels;
    return hotels.filter(h => `${h.name} ${h.city} ${h.address}`.toLowerCase().includes(qq));
  }, [hotels, q]);

  return (
    <Box p={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Hotels</Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" onClick={() => {
            const ts = new Date();
            const csv = ['id,name,city,stars'].concat(filtered.map(h => `${h.id},"${h.name}","${h.city}",${h.stars||''}`)).join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            const pad = (n:number)=> String(n).padStart(2,'0');
            a.href = url; a.download = `hotels_${ts.getFullYear()}${pad(ts.getMonth()+1)}${pad(ts.getDate())}_${pad(ts.getHours())}${pad(ts.getMinutes())}.csv`; a.click();
            URL.revokeObjectURL(url);
          }}>Export CSV</Button>
          <Button variant="contained" onClick={() => nav('/dashboard/hotels/new')}>Create</Button>
        </Stack>
      </Stack>
      <TextField fullWidth placeholder="Search..." value={q} onChange={(e)=>setQ(e.target.value)} sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {filtered.map(h => (
          <Grid item xs={12} sm={6} md={4} key={h.id}>
            <Card>
              <CardActionArea onClick={()=> nav(`/dashboard/hotels/${h.id}`)}>
                <CardContent>
                  <Typography variant="h6">{h.name}</Typography>
                  <Typography color="text.secondary">{h.city}</Typography>
                  {h.stars ? <Typography>Stars: {h.stars}</Typography> : null}
                </CardContent>
              </CardActionArea>
              <CardActions sx={{ justifyContent:'flex-end' }}>
                <Button size="small" onClick={()=> nav(`/dashboard/hotels/${h.id}`)}>Edit</Button>
                {/* Room Types button removed – managed via Hotel Rooms */}
                <Button size="small" onClick={()=> nav(`/dashboard/hotels/${h.id}?tab=media`)}>Media</Button>
                <Button size="small" onClick={()=> nav(`/dashboard/hotels/${h.id}?tab=availability`)}>Availability</Button>
                <Button size="small" onClick={()=> nav(`/dashboard/hotels/${h.id}?tab=promos`)}>Promos/Extras</Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HotelsPage;


